import { css as o } from "styled-components";
import { f as t } from "./creditFigmaToken-9b4c3a39.js";
const f = o`
  @font-face {
    font-family: 'FordF1-Bold';
    font-weight: 700;
    src: url('https://www.ford.com/finance/content/dam/ucl/fomo/fonts/FordF-1-Bold.otf') format('opentype');
    font-display: block;
  }
  @font-face {
    font-family: 'FordF1-Semibold';
    font-weight: 600;
    src: url('https://www.ford.com/finance/content/dam/ucl/fomo/fonts/FordF-1-Semibold.otf') format('opentype');
    font-display: block;
  }
  @font-face {
    font-family: 'FordF1-Regular';
    font-weight: 400;
    src: url('https://www.ford.com/finance/content/dam/ucl/fomo/fonts/FordF-1-Regular.otf') format('opentype');
    font-display: block;
  }
  @font-face {
    font-family: 'FordF1-Medium';
    font-weight: 500;
    src: url('https://www.ford.com/finance/content/dam/ucl/fomo/fonts/FordF-1-Medium.otf') format('opentype');
    font-display: block;
  }
  @font-face {
    font-family: 'FordF1-Light';
    font-weight: 300;
    src: url('https://www.ford.com/finance/content/dam/ucl/fomo/fonts/FordF-1-Light.otf') format('opentype');
    font-display: block;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    ${o(t.semanticMode1.body1.regular.value).join(`
`)}
  }
`, r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FordCreditGlobalStyles: f
}, Symbol.toStringTag, { value: "Module" }));
export {
  f as F,
  r as f
};
